(function($){
    $(document).ready(function(){

        var $localVideoButton = $('.content-video__play--local-video'),
            $youtubeButton    = $('.content-video__play--youtube'),
            $vimeoButton      = $('.content-video__play--vimeo'),
            videoId           = null,
            videoUrl          = null;

        $youtubeButton.one('click', function(event){

            event.preventDefault();
            $(this).closest('.content-video__play').fadeOut();

            var $contentVideo = $(event.target).closest('.content-video');
            var $poster = $contentVideo.find('.content-video__poster');

            videoId = $(this).attr('data-video-id');
            videoUrl = $(this).attr('data-video-url');
            $poster.animate({opacity: 0}, 300, 'linear', function(){
                $contentVideo.append('<iframe src="'+videoUrl+'?rel=0&autoplay=1&showinfo=0" width="100%" height="100%" type="text/html" frameborder="0" allow="autoplay"></iframe>');
                $(this).hide();
            });

            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        });

        $vimeoButton.one('click', function(event){

            event.preventDefault();
            $(this).closest('.content-video__play').fadeOut();

            var $contentVideo = $(event.target).closest('.content-video');
            var $poster = $contentVideo.find('.content-video__poster');

            videoId = $(this).attr('data-video-id');
            videoUrl = $(this).attr('data-video-url');
            $poster.animate({opacity: 0}, 300, 'linear', function(){
                $contentVideo.append('<iframe src="'+videoUrl+'?autoplay=1&byline=false&title=false" class="c-video width="100%" height="100%" frameborder="0" allow="autoplay"></iframe>');
                $(this).hide();
            });
        });

        $localVideoButton.one('click', function(event){

            event.preventDefault();
            $(this).closest('.content-video__play').fadeOut();

            var $contentVideo = $(event.target).closest('.content-video');
            var $poster = $contentVideo.find('.content-video__poster');

            $contentVideo.find('video').remove();

            videoId = $(this).attr('data-video-id');
            videoUrl = $(this).attr('data-video-url');
            $poster.animate({opacity: 0}, 300, 'linear', function(){
                $contentVideo.append('<video preload="auto" autoplay="true" playsinline="" tabindex="0" controls="true" class="c-video"><source src="'+videoUrl+'" type="video/mp4">Your browser does not support the video tag.</video>');
                $(this).hide();
            });
        });


    });
}(jQuery));

function forceStopVideos(){
    var $container = jQuery('.gallery-box__mobile-slide, .gallery-box__desktop-slide');
    $container.each(function(){
        jQuery(this).find('iframe').remove();
        jQuery(this).find('video').remove();
        jQuery(this).find('picture').css({opacity: 1, display: 'block'});
    });
}
